import React, {Component} from 'react'
import './RegistrationWorkerSplash.css'
import { NavLink } from 'react-router-dom'

export default class RegistrationWorkerSplash extends Component {
  render () {
    return (
      <div className="main-container container">
        <div className="row">
          <div className="info-box text-center">
            <h2 className="title"> Scegli tra le seguenti opzioni e clicca Vai</h2>
          </div>
        </div>
        <div className="row">
          {/* <div className="col-md-offset-1"> */}
          <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div className="panel panel-default panel-border">
              <div className="panel-body text-left">
                <h3 className="title3">Dipendente</h3>
                <div className="panel-body flex-grow panel-2">
                  Lavori presso un attività con sede nelle zone del piano di Sosta
                </div>
                <NavLink className="panel-footer register-footer btn-green btn-block" to={'/register/worker/employees'}>
                  VAI <span className="glyphicon glyphicon-arrow-right">{}</span>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div className="panel panel-default panel-border">
              <div className="panel-body text-left">
                <h3 className="title3">Titolare attività economica</h3>
                <div className="panel-body flex-grow panel-2">
                  Sei titolare di un attività con sede nelle zone del Piano di Sosta
                </div>
                <NavLink
                  className="panel-footer register-footer btn-green btn-block"
                  to={'/register/worker/economy-activity-holder'}>
                  VAI <span className="glyphicon glyphicon-arrow-right">{}</span>
                </NavLink>
              </div>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <div className="panel panel-default panel-border">
              <div className="panel-body text-left">
                <h3 className="title3">Veicoli Aziendali</h3>
                <div className="panel-body flex-grow panel-2">
                  Un azienda che possiede veicoli aziendali
                </div>
                <br />
                <NavLink
                  className="panel-footer register-footer btn-green btn-block"
                  to={'/register/worker/company-vehicles'}>
                  VAI <span className="glyphicon glyphicon-arrow-right">{}</span>
                </NavLink>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
        <div className="row">
          {/* <div className="col-md-offset-2 col-sm-offset-2 col-lg-offset-2 col-xl-offset-2"> */}
          <div className="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-md-offset-2 col-sm-offset-2 col-lg-offset-2 col-xl-offset-2">
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div className="panel panel-default panel-border">
                  <div className="panel-body text-left">
                    <h3 className="title3">Enti Assistenza</h3>
                    <div className="panel-body flex-grow panel-2">
                      Un ente di assistenza che possiede veicoli
                    </div>
                    <br />
                    <NavLink className="panel-footer register-footer btn-green btn-block" to={'/register/worker/support-organizations'}>
                      VAI <span className="glyphicon glyphicon-arrow-right">{}</span>
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div className="panel panel-default panel-border">
                  <div className="panel-body text-left">
                    <h3 className="title3">Strutture Ricettive</h3>
                    <div className="panel-body flex-grow panel-2">
                      Una struttura ricettiva che può utilizzare il proprio contrassegno per la sosta dei suoi clienti.<br />
                      Recati allo sportello per richiedere il rilascio di questa categoria di contassegno
                    </div>
                    <a className="panel-footer register-footer btn-green btn-block" href={'mailto: infosostaempoli@lineservizi.it'}>
                      RICHIEDI INFORMAZIONI <span className="glyphicon glyphicon-arrow-right">{}</span>
                    </a>
                    {/* <button disabled={true} className="panel-footer register-footer btn btn-block">
                                            DISPONIBILE A BREVE
                                        </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Registration/WorkerSplash/RegistrationWorkerSplash.js